import handleInit from './handleInit';
import handleSwitch from './handleSwitch';
import handleSorting from './handleSorting';

/**
 * Attach interactions to every element that matches selector.
 */
$('.switcher').each((_, component) => {
    $(component).on('change', '.select', handleSwitch(component));
    $(window).on('load', handleInit(component));
    $(window).on('load', handleSorting(component));
});



// WEBPACK FOOTER //
// ./src/scripts/components/switcher/index.js